module.exports = __webpack_public_path__ + "img/image-placeholder.b1fc033e.png";